<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="association-settings-upload-history-covers-title">
                {{ $t('company.upload_history_covers.title') }}
            </div>
        </div>
        <upload-log-table
            :association_id="association_id"
            :is_association_section="true"
            @onTableAction="onTableAction"
            @onActionButtons="onActionButtons"
            ref="UploadLogTable"
        />
        <a-drawer
            data-cy="upload-drawer"
            :title="$t('company.upload_history.drawer.title')"
            :width="500"
            :open="drawer_visible"
            :body-style="{ padding: '0px', paddingBottom: '10px' }"
            :destroyOnClose="true"
            :maskClosable="false"
            :rootClassName="'epic-' + moduleStateLink"
            @close="onClose"
        >
            <view-upload-log :is_association_section="true" :upload_log="upload_log" @onDrawerClose="onClose" />
        </a-drawer>
    </div>
</template>

<script>
import UploadLogTable from '@/components/tables/UploadLogsCovers.vue';
import ViewUploadLog from '@/components/views/UploadLogCover.vue';

export default {
    components: {
        UploadLogTable,
        ViewUploadLog,
    },
    props: {
        association_id: {
            type: String,
            default: '',
        },
    },
    data() {
        return { drawer_visible: false, upload_log: {} };
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        onTableAction(data) {
            switch (data.key) {
                case 'open':
                    this.$http.get('/api/cover-import-audit-logs/' + data.id).then((response) => {
                        this.upload_log = {
                            ...response.data.data,
                            created_at: this.$dayjs(response.data.data.created_at).format('YYYY-MM-DD HH:mm:ss'),
                        };
                    });

                    this.drawer_visible = true;
                    break;
                case 'resend_email':
                    this.resendConfirmation([data.id]);
                    break;
            }
        },
        onClose() {
            this.drawer_visible = false;
        },
        onActionButtons(event, type) {
            switch (event.key) {
                case 'resend_email':
                    this.resendConfirmation(type);
                    break;
            }
        },
        resendConfirmation(ids) {
            this.$http
                .post('/api/cover-import-audit-logs/resend-confirmation', { ids: ids })
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$notification.success({
                            message: response.data.message,
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'UHCV02' }),
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.$refs.UploadLogTable.reload();
                });
        },
        reload() {
            this.$refs.UploadLogTable.reload();
        },
    },
};
</script>
